import ParticipantDetailDialogComponent from "./participantDetailDialog.container";

export default ParticipantDetailDialogComponent;